// Desktop (Haseeb, 26 Oct 2026: "desktop full screen"): a landscape viewport at least 1024 px wide and 640 px tall. One
// query for every player screen; phones and tablets held upright (a 13-inch iPad is 1024 wide) never match it. Where matchMedia is missing (tests) it is false.
import { useMedia } from '@/studio/useMedia';

export const DESKTOP_QUERY = '(min-width: 1024px) and (min-height: 640px) and (orientation: landscape)';
export const useDesktop = (): boolean => useMedia(DESKTOP_QUERY, false);
